module.exports = __webpack_public_path__ + "static/media/app icon (2).fbfddba8.png";